import { atom } from 'recoil';

const centerState = atom({
    key: 'center',
    default: null
});

export default centerState;